import url from './url';



export default url(({ feedSource, date = ':date' }) => `/${feedSource}/${date}/edit`);
